import { combineReducers } from 'redux';
import { default as list } from 'depreciations/reducers/depreciations_list_reducers';
import { default as form } from 'depreciations/reducers/depreciations_form_reducers';

export const depreciationsReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/reducers/index.js